module.exports = __webpack_public_path__ + "img/l-han.32bd451d.svg";